import React from 'react';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import cn from 'classnames';

import useDevicesListLogic from './hooks/useDevicesListLogic';
import DevicesItem from './DevicesItem';
import DeviceEditForm from './DeviceEditForm';
import Empty from '@components/snippets/Empty';

function DevicesList(props) {
  const {
    t,
    device,
    loading,
    devices,
    calendars,
    activeId,
    screenshot,
    isOpen,
    logs,
    toggle,
    onClick,
    onLogsRequest,
    onClose,
    onDeleteDevice,
    onEdit,
    onDeactivate,
    createInitialValues,
    onGetScreenshot,
  } = useDevicesListLogic(props);

  return (
    <div
      className={cn('devices-page__devices devices', {
        'devices-page__devices--empty': !loading && isEmpty(devices),
      })}
    >
      {!loading && isEmpty(devices) ? (
        <Empty style={{ margin: 'auto' }} text={t('empty-devices')} />
      ) : (
        [
          map(devices, (device) => (
            <DevicesItem
              t={t}
              loading={loading}
              active={activeId === device.id}
              onClick={onClick(device.id)}
              onDelete={onDeleteDevice(device.id)}
              {...device}
            />
          )),
          <DeviceEditForm
            t={t}
            loading={loading}
            logs={logs}
            onLogsRequest={onLogsRequest}
            visible={isOpen}
            onClose={onClose}
            calendars={calendars}
            device={device}
            screenshot={screenshot}
            onGetScreenshot={onGetScreenshot}
            onDelete={onDeleteDevice(device.id, toggle)}
            onEdit={onEdit(device)}
            onDeactivate={onDeactivate(device.id)}
            initialValues={createInitialValues()}
          />,
        ]
      )}
    </div>
  );
}

export default DevicesList;
